// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/causali-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, tipo, gestisceIva, sezionaleIvaDefaultId, sezionaleIva: { codice, descrizione }, registroContabileDefaultId, registroContabile: { codice, descrizione }, isDefault, attivo, note, nRighe, daCompletare, dettagliDaCompletare }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/causali-contabili',
    requestBody: '{ societaId, codice, descrizione, tipo, gestisceIva, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/causali-contabili/:id/stato',
    requestBody: '{ attivo }',
    response: '{ success: true }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/causali-contabili/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
